import { RoughSVG } from "roughjs/bin/svg";
import oc from "open-color";
import {getHoverHandles, getQuickFlowHandles } from "../element/resizeTest";
import {
  InteractiveCanvasAppState,
  StaticCanvasAppState,
  BinaryFiles,
  Point,
  Zoom,
  AppState,
} from "../types";
import {
  ExcalidrawElement,
  NonDeletedExcalidrawElement,
  ExcalidrawLinearElement,
  NonDeleted,
  GroupId,
  ExcalidrawBindableElement,
  ExcalidrawFrameLikeElement,
} from "../element/types";
import {
  getElementAbsoluteCoords,
  OMIT_SIDES_FOR_MULTIPLE_ELEMENTS,
  getTransformHandlesFromCoords,
  getTransformHandles,
  getCommonBounds, isTextElement,
} from "../element";

import { roundRect } from "./roundRect";
import {
  InteractiveCanvasRenderConfig,
  InteractiveSceneRenderConfig,
  SVGRenderConfig,
  StaticCanvasRenderConfig,
  StaticSceneRenderConfig,
} from "../scene/types";
import {
  getScrollBars,
  SCROLLBAR_COLOR,
  SCROLLBAR_WIDTH,
} from "../scene/scrollbars";

import {
  renderElement,
  renderElementToSvg,
  renderSelectionElement,
} from "./renderElement";
import { getClientColor } from "../clients";
import { LinearElementEditor } from "../element/linearElementEditor";
import {
  isSelectedViaGroup,
  getSelectedGroupIds,
  getElementsInGroup,
  selectGroupsFromGivenElements,
} from "../groups";
import { maxBindingGap } from "../element/collision";
import { SuggestedBinding, SuggestedPointBinding } from "../element/binding";
import {
  OMIT_SIDES_FOR_FRAME,
  shouldShowBoundingBox,
  TransformHandles,
  TransformHandleType,
} from "../element/transformHandles";
import { throttleRAF } from "../utils";
import { UserIdleState } from "../types";
import {FRAME_STYLE, IMAGE_MIME_TYPES, THEME_FILTER, VIDEO_ELEMENT_RADIUS} from "../constants";
import {
  EXTERNAL_LINK_IMG,
  getLinkHandleFromCoords, getRotateImg,
} from "../element/Hyperlink";
import { renderSnaps } from "./renderSnaps";
import {
  isEmbeddableElement,
  isFrameLikeElement,
  isIframeLikeElement, isImageElement,
  isLinearElement, isMindmapElement, isProjectLinkElement, isShapeElement, isStickyNotesElement,
} from "../element/typeChecks";
import {
  isIframeLikeOrItsLabel,
  createPlaceholderEmbeddableLabel,
} from "../element/embeddable";
import {
  elementOverlapsWithFrame,
  getTargetFrame,
  isElementInFrame,
} from "../frame";
import "canvas-roundrect-polyfill";
import {
  imgPathPerfix, isAnnoElement, isAudioFileElement,
  isDarkMode, isDeepLink,
  isFileElement,
  isFileVideoElement, isLinkAndNotExist,
  isNoteElement, isPdfAnnoElement,
  isPdfFileElement
} from "../../../../src/utils";
import {APP_WEB} from "../../../../src/electron_interactive";
import Global from "../../../../src/global";
import {getElementSelectionBorderColor, HAS_ENABLE_TIPTAP_TEXT, HOVER_CIRCLE_ELEMENT_SIZE} from "../../../../src/Const";
import { rotate } from "../math";
import {mindMapCache} from "../element/mindMap";
import {mutateElement} from "../element/mutateElement";
import app from "../components/App";

export const quickFlowElementsType = [
  "rectangle",
  "roundedRectangle",
  "ellipse",
  "triangle",
  "diamond",
  "bubble",
  "parallelogram",
  "pentagram",
];
export const DEFAULT_SPACING = 0;//2;
export const DEFAULT_QUICKFLOW_SPACING = 26;
const IMAGE_ROTATE_SIZE= 20;
export let normalizedSize: {
  normalizedWidth: number;
  normalizedHeight: number;
} | null = null;
export let pageSize:
    | {
  x: number;
  y: number;
  clipWidth: number;
  clipHeight: number;
}
    | undefined = undefined;
const strokeRectWithRotation = (
  context: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  cx: number,
  cy: number,
  angle: number,
  fill: boolean = false,
  /** should account for zoom */
  radius: number = 0,
) => {
  context.save();
  context.translate(cx, cy);
  context.rotate(angle);
  if (fill) {
    context.fillRect(x - cx, y - cy, width, height);
  }
  if (radius && context.roundRect) {
    context.beginPath();
    context.roundRect(x - cx, y - cy, width, height, radius);
    context.stroke();
    context.closePath();
  } else {
    context.strokeRect(x - cx, y - cy, width, height);
  }
  context.restore();
};

const strokeDiamondWithRotation = (
  context: CanvasRenderingContext2D,
  width: number,
  height: number,
  cx: number,
  cy: number,
  angle: number,
) => {
  context.save();
  context.translate(cx, cy);
  context.rotate(angle);
  context.beginPath();
  context.moveTo(0, height / 2);
  context.lineTo(width / 2, 0);
  context.lineTo(0, -height / 2);
  context.lineTo(-width / 2, 0);
  context.closePath();
  context.stroke();
  context.restore();
};

const strokeEllipseWithRotation = (
  context: CanvasRenderingContext2D,
  width: number,
  height: number,
  cx: number,
  cy: number,
  angle: number,
) => {
  context.beginPath();
  context.ellipse(cx, cy, width / 2, height / 2, angle, 0, Math.PI * 2);
  context.stroke();
};

const fillCircle = (
  context: CanvasRenderingContext2D,
  cx: number,
  cy: number,
  radius: number,
  stroke = true,
  isQuickFlow = false,
) => {
  context.beginPath();
  context.arc(cx, cy, radius, 0, Math.PI * 2);
  // if (isQuickFlow) {
  //   context.strokeStyle = '#FFFFFF11';
  //   context.lineWidth = 2;
  //   // context.fillStyle = isDarkMode()?"#4A5877":"#00000033"; // 设置填充颜色
  //   context.fillStyle = '#3670F7';
  // }
  context.fill();
  if (stroke) {
    context.stroke();
  }
};

const fillRotateImage = (context: CanvasRenderingContext2D,
                         cx: number,
                         cy: number)=>{
  var img = new Image();
  img.src = imgPathPerfix()+"rotate.png";
  img.onload = function (){
    context.beginPath();
   context.drawImage(img,cx,cy,IMAGE_ROTATE_SIZE,IMAGE_ROTATE_SIZE);
    context.fill();
  }
}

const strokeGrid = (
    context: CanvasRenderingContext2D,
    gridSize: number,
    scrollX: number,
    scrollY: number,
    zoom: Zoom,
    width: number,
    height: number,
) => {
  const BOLD_LINE_FREQUENCY = 5;
  const DOT_SIZE = 1; // 定义点的直径

  enum GridLineColor {
    Bold = "#cccccc",
    Regular = "#E6E6E6",
  }

  const offsetX =
      -Math.round(zoom.value / gridSize) * gridSize + (scrollX % gridSize);
  const offsetY =
      -Math.round(zoom.value / gridSize) * gridSize + (scrollY % gridSize);

  context.save();

  // 遍历Canvas的宽度，每隔15px绘制一个点
  for (let x = offsetX; x < offsetX + width + gridSize * 2; x += gridSize) {
    // 遍历Canvas的高度，每隔15px绘制一个点
    for (let y = offsetY; y < offsetY + height + gridSize * 2; y += gridSize) {
      // const isBold =
      //   Math.round(x - scrollX) % (BOLD_LINE_FREQUENCY * gridSize) === 0 &&
      //   Math.round(y - scrollY) % (BOLD_LINE_FREQUENCY * gridSize) === 0;
      context.beginPath();
      // context.fillStyle = isBold ? GridLineColor.Bold : GridLineColor.Regular;
      context.fillStyle = GridLineColor.Regular;
      // context.fillStyle =
      // zoom.value < 1 ? GridLineColor.Bold : GridLineColor.Regular;
      // let adjustedDotSize = DOT_SIZE * zoom.value;
      let adjustedDotSize = 1;
      if (zoom.value < 1) {
        adjustedDotSize = 1.2;
      }
      context.arc(x, y, adjustedDotSize, 0, Math.PI * 2);

      context.fill();
    }
  }

  context.restore();
};

/*
const strokeGrid = (
  context: CanvasRenderingContext2D,
  gridSize: number,
  scrollX: number,
  scrollY: number,
  zoom: Zoom,
  width: number,
  height: number,
) => {
  const BOLD_LINE_FREQUENCY = 5;
  const DOT_SIZE = 1; // 定义点的直径

  enum GridLineColor {
    Bold = "#cccccc",
    Regular = "#E6E6E6",
  }

  const offsetX =
    -Math.round(zoom.value / gridSize) * gridSize + (scrollX % gridSize);
  const offsetY =
    -Math.round(zoom.value / gridSize) * gridSize + (scrollY % gridSize);

  const lineWidth = Math.min(1 / zoom.value, 1);

  const spaceWidth = 1 / zoom.value;
  const lineDash = [lineWidth * 3, spaceWidth + (lineWidth + spaceWidth)];

  context.save();
  context.lineWidth = lineWidth;

  for (let x = offsetX; x < offsetX + width + gridSize * 2; x += gridSize) {
    const isBold =
      Math.round(x - scrollX) % (BOLD_LINE_FREQUENCY * gridSize) === 0;
    context.beginPath();
    context.setLineDash(isBold ? [] : lineDash);
    context.strokeStyle = isBold ? GridLineColor.Bold : GridLineColor.Regular;
    context.moveTo(x, offsetY - gridSize);
    context.lineTo(x, offsetY + height + gridSize * 2);
    context.stroke();
  }
  for (let y = offsetY; y < offsetY + height + gridSize * 2; y += gridSize) {
    const isBold =
      Math.round(y - scrollY) % (BOLD_LINE_FREQUENCY * gridSize) === 0;
    context.beginPath();
    context.setLineDash(isBold ? [] : lineDash);
    context.strokeStyle = isBold ? GridLineColor.Bold : GridLineColor.Regular;
    context.moveTo(offsetX - gridSize, y);
    context.lineTo(offsetX + width + gridSize * 2, y);
    context.stroke();
  }
  context.restore();
};

 */

const renderSingleLinearPoint = (
  context: CanvasRenderingContext2D,
  appState: InteractiveCanvasAppState,
  point: Point,
  radius: number,
  isSelected: boolean,
  isPhantomPoint = false,
) => {
  context.strokeStyle = "#5e5ad8";
  context.setLineDash([]);
  context.fillStyle = "rgba(255, 255, 255, 0.9)";
  if (isSelected) {
    context.fillStyle = "rgba(134, 131, 226, 0.9)";
  } else if (isPhantomPoint) {
    context.fillStyle = "rgba(177, 151, 252, 0.7)";
  }

  fillCircle(
    context,
    point[0],
    point[1],
    radius / appState.zoom.value,
    !isPhantomPoint,
  );
};

const renderLinearPointHandles = (
  context: CanvasRenderingContext2D,
  appState: InteractiveCanvasAppState,
  element: NonDeleted<ExcalidrawLinearElement>,
) => {
  if (!appState.selectedLinearElement) {
    return;
  }
  context.save();
  context.translate(appState.scrollX, appState.scrollY);
  context.lineWidth = 1 / appState.zoom.value;
  const points = LinearElementEditor.getPointsGlobalCoordinates(element);

  const { POINT_HANDLE_SIZE } = LinearElementEditor;
  const radius = appState.editingLinearElement
    ? POINT_HANDLE_SIZE
    : POINT_HANDLE_SIZE / 2;
  points.forEach((point, idx) => {
    const isSelected =
      !!appState.editingLinearElement?.selectedPointsIndices?.includes(idx);

    renderSingleLinearPoint(context, appState, point, radius, isSelected);
  });

  //Rendering segment mid points
  const midPoints = LinearElementEditor.getEditorMidPoints(
    element,
    appState,
  ).filter((midPoint) => midPoint !== null) as Point[];

  if (midPoints.length > 1) {
    midPoints.forEach((segmentMidPoint) => {
      if (
          appState?.selectedLinearElement?.segmentMidPointHoveredCoords &&
          LinearElementEditor.arePointsEqual(
              segmentMidPoint,
              appState.selectedLinearElement.segmentMidPointHoveredCoords,
          )
      ) {
        // The order of renderingSingleLinearPoint and highLight points is different
        // inside vs outside editor as hover states are different,
        // in editor when hovered the original point is not visible as hover state fully covers it whereas outside the
        // editor original point is visible and hover state is just an outer circle.
        if (appState.editingLinearElement) {
          renderSingleLinearPoint(
              context,
              appState,
              segmentMidPoint,
              radius,
              false,
          );
          highlightPoint(segmentMidPoint, context, appState);
        } else {
          highlightPoint(segmentMidPoint, context, appState);
          renderSingleLinearPoint(
              context,
              appState,
              segmentMidPoint,
              radius,
              false,
          );
        }
      } else if (appState.editingLinearElement || points.length === 2) {
        renderSingleLinearPoint(
            context,
            appState,
            segmentMidPoint,
            POINT_HANDLE_SIZE / 2,
            false,
            true,
        );
      }
    });
  }

  context.restore();
};

const highlightPoint = (
  point: Point,
  context: CanvasRenderingContext2D,
  appState: InteractiveCanvasAppState,
) => {
  context.fillStyle = "rgba(105, 101, 219, 0.4)";

  fillCircle(
    context,
    point[0],
    point[1],
    LinearElementEditor.POINT_HANDLE_SIZE / appState.zoom.value,
    false,
  );
};
const renderLinearElementPointHighlight = (
  context: CanvasRenderingContext2D,
  appState: InteractiveCanvasAppState,
) => {
  const { elementId, hoverPointIndex } = appState.selectedLinearElement!;
  if (
    appState.editingLinearElement?.selectedPointsIndices?.includes(
      hoverPointIndex,
    )
  ) {
    return;
  }
  const element = LinearElementEditor.getElement(elementId);
  if (!element) {
    return;
  }
  const point = LinearElementEditor.getPointAtIndexGlobalCoordinates(
    element,
    hoverPointIndex,
  );
  context.save();
  context.translate(appState.scrollX, appState.scrollY);

  highlightPoint(point, context, appState);
  context.restore();
};

const frameClip = (
  frame: ExcalidrawFrameLikeElement,
  context: CanvasRenderingContext2D,
  renderConfig: StaticCanvasRenderConfig,
  appState: StaticCanvasAppState,
) => {
  context.translate(frame.x + appState.scrollX, frame.y + appState.scrollY);
  context.beginPath();
  if (context.roundRect) {
    context.roundRect(
      0,
      0,
      frame.width,
      frame.height,
      FRAME_STYLE.radius / appState.zoom.value,
    );
  } else {
    context.rect(0, 0, frame.width, frame.height);
  }
  context.clip();
  context.translate(
    -(frame.x + appState.scrollX),
    -(frame.y + appState.scrollY),
  );
};

const getNormalizedCanvasDimensions = (
  canvas: HTMLCanvasElement,
  scale: number,
): [number, number] => {
  // When doing calculations based on canvas width we should used normalized one
  return [canvas.width / scale, canvas.height / scale];
};

const bootstrapCanvas = ({
  canvas,
  scale,
  normalizedWidth,
  normalizedHeight,
  theme,
  isExporting,
  viewBackgroundColor,
                           pageSizeValues,
}: {
  canvas: HTMLCanvasElement;
  scale: number;
  normalizedWidth: number;
  normalizedHeight: number;
  theme?: AppState["theme"];
  isExporting?: StaticCanvasRenderConfig["isExporting"];
  viewBackgroundColor?: StaticCanvasAppState["viewBackgroundColor"];
  pageSizeValues?: StaticCanvasAppState["pageSizeValues"];
}): CanvasRenderingContext2D => {
  const context = canvas.getContext("2d")!;

  context.setTransform(1, 0, 0, 1, 0, 0);
  context.scale(scale, scale);

  if (isExporting && theme === "dark") {
    context.filter = THEME_FILTER;
  }

  // let pageSize:
  //     | {
  //   x: number;
  //   y: number;
  //   clipWidth: number;
  //   clipHeight: number;
  // }
  //     | undefined = undefined;
  if (pageSizeValues) {
    pageSize = setCanvasPageSize({
      context,
      normalizedWidth,
      normalizedHeight,
      pageSizeValues,
    });
  }


  // Paint background
  if (typeof viewBackgroundColor === "string") {
    const hasTransparence =
      viewBackgroundColor === "transparent" ||
      viewBackgroundColor.length === 5 || // #RGBA
      viewBackgroundColor.length === 9 || // #RRGGBBA
      /(hsla|rgba)\(/.test(viewBackgroundColor);
    if (hasTransparence) {
      context.clearRect(0, 0, normalizedWidth, normalizedHeight);
    }
    context.save();
    context.fillStyle = viewBackgroundColor;
    if (pageSize) {
      context.fillRect(
          pageSize.x,
          pageSize.y,
          pageSize.clipWidth,
          pageSize.clipHeight,
      );
    } else {
      context.fillRect(0, 0, normalizedWidth, normalizedHeight);
    }

    context.restore();
  } else {
    context.clearRect(0, 0, normalizedWidth, normalizedHeight);
  }

  return context;
};

const _renderInteractiveScene = ({
  canvas,
  elements,
  visibleElements,
  selectedElements,
  scale,
  appState,
  renderConfig,
}: InteractiveSceneRenderConfig) => {
  if (canvas === null) {
    return { atLeastOneVisibleElement: false, elements };
  }

  const [normalizedWidth, normalizedHeight] = getNormalizedCanvasDimensions(
    canvas,
    scale,
  );

  const context = bootstrapCanvas({
    canvas,
    scale,
    normalizedWidth,
    normalizedHeight,
  });

  // Apply zoom
  context.save();
  context.scale(appState.zoom.value, appState.zoom.value);

  let editingLinearElement: NonDeleted<ExcalidrawLinearElement> | undefined =
    undefined;

  visibleElements.forEach((element) => {
    // Getting the element using LinearElementEditor during collab mismatches version - being one head of visible elements due to
    // ShapeCache returns empty hence making sure that we get the
    // correct element from visible elements
    if (appState.editingLinearElement?.elementId === element.id) {
      if (element) {
        editingLinearElement = element as NonDeleted<ExcalidrawLinearElement>;
      }
    }
  });

  if (editingLinearElement) {
    renderLinearPointHandles(context, appState, editingLinearElement);
  }

  // Paint selection element
  if (appState.selectionElement) {
    try {
      renderSelectionElement(appState.selectionElement, context, appState);
    } catch (error: any) {
      console.error(error);
    }
  }

  if (appState.isBindingEnabled) {
    appState.suggestedBindings
      .filter((binding) => binding != null)
      .forEach((suggestedBinding) => {
        renderBindingHighlight(context, appState, suggestedBinding!);
      });
  }

  if (appState.frameToHighlight) {
    renderFrameHighlight(context, appState, appState.frameToHighlight);
  }

  if (appState.elementsToHighlight) {
    renderElementsBoxHighlight(context, appState, appState.elementsToHighlight);
  }

  const isFrameSelected = selectedElements.some((element) =>
    isFrameLikeElement(element),
  );

  // Getting the element using LinearElementEditor during collab mismatches version - being one head of visible elements due to
  // ShapeCache returns empty hence making sure that we get the
  // correct element from visible elements
  if (
    selectedElements.length === 1 &&
    appState.editingLinearElement?.elementId === selectedElements[0].id
  ) {
    renderLinearPointHandles(
      context,
      appState,
      selectedElements[0] as NonDeleted<ExcalidrawLinearElement>,
    );
  }

  if (
    appState.selectedLinearElement &&
    appState.selectedLinearElement.hoverPointIndex >= 0
  ) {
    renderLinearElementPointHighlight(context, appState);
  }
  // Paint selected elements
  if (!appState.multiElement && !appState.editingLinearElement) {
    const isSingleStickyNotesElementSelectedActive =
        selectedElements.length === 1 &&
        isStickyNotesElement(selectedElements[0]) &&
        selectedElements[0].isActive;

    const showBoundingBox = shouldShowBoundingBox(selectedElements, appState);

    const isSingleLinearElementSelected =
      selectedElements.length === 1 && isLinearElement(selectedElements[0]);
    // render selected linear element points
    if (
      isSingleLinearElementSelected &&
      appState.selectedLinearElement?.elementId === selectedElements[0].id &&
      !selectedElements[0].locked
    ) {
      renderLinearPointHandles(
        context,
        appState,
        selectedElements[0] as ExcalidrawLinearElement,
      );
    }

    let selectionColor = getElementSelectionBorderColor()//renderConfig.selectionColor || oc.black;
    if (selectedElements.length == 1 && (isNoteElement(selectedElements[0]) || isPdfAnnoElement(selectedElements[0]))){
      if (Global.g_isCanvasCardMouseDown){
        selectionColor = 'transparent';
      }
      // if (selectedElements[0].customData?.generationData?.isEditable){
      //   selectionColor = '#4B4B4B';
      // }
    }

    if (showBoundingBox) {
      // Optimisation for finding quickly relevant element ids
      const locallySelectedIds = selectedElements.reduce(
        (acc: Record<string, boolean>, element) => {
          acc[element.id] = true;
          return acc;
        },
        {},
      );

      //修复mindmap变小问题。。。可能有问题....
      // const arrayNew = [];
      // elements.forEach(p=>{
      //   const newItem:any = {...p};
      //   if (isMindmapElement(p)){
      //     const newMindmap:any = mindMapCache.get(p.id);
      //     if (newMindmap){
      //       if (p.width != newMindmap.width || p.height != newMindmap.height){
      //         // mutateElement(p,{width:newMindmap.width,height:newMindmap.height});
      //         newItem.width = newMindmap.width;
      //         newItem.height = newMindmap.height;
      //       }
      //     }
      //   }
      //   arrayNew.push(newItem);
      // })

      const selections = elements.reduce(
        (
          acc: {
            angle: number;
            elementX1: number;
            elementY1: number;
            elementX2: number;
            elementY2: number;
            selectionColors: string[];
            dashed?: boolean;
            cx: number;
            cy: number;
            activeEmbeddable: boolean;
            corner:any;
          }[],
          element,
        ) => {
          const selectionColors = [];
          // local user
          // local user
          // NOTE: 连接线/箭头在组选/多选场景下保持“选中状态”，但不显示单独的选中框，
          // 避免视觉噪音（仍可在右侧面板修改属性）。
          if (
            locallySelectedIds[element.id] &&
            !isSelectedViaGroup(appState, element) &&
              !(selectedElements.length > 1 && isLinearElement(element))
          ) {
            //不管是多选还是单选.设置选中的颜色---不管是多选还是单选.设置选中的颜色---不管是多选还是单选.设置选中的颜色---不管是多选还是单选.设置选中的颜色---不管是多选还是单选.设置选中的颜色---不管是多选还是单选.设置选中的颜色---不管是多选还是单选.设置选中的颜色---不管是多选还是单选.设置选中的颜色---
            let newSelectionColor = selectionColor;
            let isGif = false;
            if (isImageElement(element)){
              // if (window.getAppFiles){
              //   const file = window.getAppFiles()[element.fileId];
              //   if (file?.mimeType == IMAGE_MIME_TYPES.gif){
              //     isGif = true;
              //   }
              // }
              if (element.customData?.generationData?.isShowInfoNotes){
                isGif = true;
              }
            }
            if (isAudioFileElement(element) ||
                isStickyNotesElement(element) ||
                isFileVideoElement(element) ||
                isPdfFileElement(element) ||
                isNoteElement(element) ||
                isFileElement(element) ||
                isAnnoElement(element) ||
                isProjectLinkElement(element) ||
                (isTextElement(element) && HAS_ENABLE_TIPTAP_TEXT) ||
                (isEmbeddableElement(element) /*&& element.embedType == 'text'*/) ||
                isGif){
              newSelectionColor = 'transparent';
            }
            selectionColors.push(newSelectionColor);
          }
          // remote users
          if (renderConfig.remoteSelectedElementIds[element.id]) {
            selectionColors.push(
              ...renderConfig.remoteSelectedElementIds[element.id].map(
                (socketId: string) => {
                  const background = getClientColor(socketId);
                  return background;
                },
              ),
            );
          }

          if (selectionColors.length) {
            const [elementX1, elementY1, elementX2, elementY2, cx, cy] =
              getElementAbsoluteCoords(element, true);
            let corner = (isFileVideoElement(element) || isLinkAndNotExist(element) || isStickyNotesElement(element))?VIDEO_ELEMENT_RADIUS:(element.roundness?.value||0);
            if (isMindmapElement(element)){
              corner = 8 / appState.zoom.value;
            }
            acc.push({
              angle: element.angle,
              elementX1,
              elementY1,
              elementX2,
              elementY2,
              selectionColors,
              dashed: !!renderConfig.remoteSelectedElementIds[element.id],
              cx,
              cy,
              activeEmbeddable:
                appState.activeEmbeddable?.element === element &&
                appState.activeEmbeddable.state === "active",
              corner:corner
            });
          }
          return acc;
        },
        [],
      );

      const addSelectionForGroupId = (groupId: GroupId) => {
        const groupElements = getElementsInGroup(elements, groupId);
        const [elementX1, elementY1, elementX2, elementY2] =
          getCommonBounds(groupElements);
        selections.push({
          angle: 0,
          elementX1,
          elementX2,
          elementY1,
          elementY2,
          selectionColors: [oc.black],
          dashed: true,
          cx: elementX1 + (elementX2 - elementX1) / 2,
          cy: elementY1 + (elementY2 - elementY1) / 2,
          activeEmbeddable: false,
        });
      };

      for (const groupId of getSelectedGroupIds(appState)) {
        // TODO: support multiplayer selected group IDs
        addSelectionForGroupId(groupId);
      }

      if (appState.editingGroupId) {
        addSelectionForGroupId(appState.editingGroupId);
      }

      //**********border......
      // selections.forEach((selection) =>
      //   renderSelectionBorder(context, appState, selection),
      // );

      if (!isSingleStickyNotesElementSelectedActive) {
        selections.forEach((selection) =>
            renderSelectionBorder(context, appState, selection),
        );
      }
    }
    // Paint resize transformHandles
    context.save();
    context.translate(appState.scrollX, appState.scrollY);

    if (selectedElements.length === 1 &&
        !isSingleStickyNotesElementSelectedActive) {
      context.fillStyle = oc.white;
      const transformHandles = getTransformHandles(
        selectedElements[0],
        appState.zoom,
        "mouse", // when we render we don't know which pointer type so use mouse
      );
      if (!appState.viewModeEnabled && showBoundingBox && !selectedElements[0].isHidden) {
        //图片,pdf不要中间的点
        if (isPdfFileElement(selectedElements[0]) || isImageElement(selectedElements[0]) || isFileElement(selectedElements[0]) || isEmbeddableElement(selectedElements[0])){
          delete transformHandles.s;
          delete transformHandles.n;
          delete transformHandles.w;
          delete transformHandles.e;
          if (!isImageElement(selectedElements[0])){
            delete transformHandles.rotation;
          }
        }
        let isDeeplink0 = false;
        if (isTextElement(selectedElements[0])){
          isDeeplink0 = isDeepLink(selectedElements[0].originalText);
          //删除四和方位
          // delete transformHandles.ne;
          // delete transformHandles.nw;
          // delete transformHandles.se;
          // delete transformHandles.sw;
        }
        if (isNoteElement(selectedElements[0]) || isAnnoElement(selectedElements[0]) || isMindmapElement(selectedElements[0]) || isDeeplink0 || isProjectLinkElement(selectedElements[0])){
          delete transformHandles.rotation;
        }
        renderTransformHandles(
          context,
          renderConfig,
          appState,
          transformHandles,
          selectedElements[0].angle,
            selectedElements[0].height
        );

        // const xyInSide = ()=>{
        //   const [x1, y1, x2, y2] = getCommonBounds(selectedElements);
        //   const x = Global.g_DrawEventXY.x - (appState.scrollX)*appState.zoom.value;
        //   const y = Global.g_DrawEventXY.y - appState.scrollY*appState.zoom.value;
        //
        //   const isIn = (x1-15)*appState.zoom.value < x && (x2+15)*appState.zoom.value > x && (y1-15)*appState.zoom.value < y && (y2+15)*appState.zoom.value > y;
        //   return isIn;
        // }

        // appState.quickFlow &&
        // !appState.selectedLinearElement &&
        // selectedElements.every((element) =>
        //     (!element.customData?.generationData?.isEditable || !(xyInSide())) && (quickFlowElementsType.includes(element.type) || (isNoteElement(element))),
        // ) &&
        // renderQuickflowHandles({
        //   context,
        //   renderConfig,
        //   appState,
        //   element: selectedElements[0],
        // });
      }
    } else if (selectedElements.length > 1 && !appState.isRotating) {
      const dashedLinePadding = (DEFAULT_SPACING * 2) / appState.zoom.value;
      context.fillStyle = oc.white;
      const [x1, y1, x2, y2] = getCommonBounds(selectedElements,false);
      const initialLineDash = context.getLineDash();
      context.setLineDash([2 / appState.zoom.value]);
      const lineWidth = context.lineWidth;
      context.lineWidth = 1 / appState.zoom.value;
      context.strokeStyle = selectionColor;
      strokeRectWithRotation(
        context,
        x1 - dashedLinePadding,
        y1 - dashedLinePadding,
        x2 - x1 + dashedLinePadding * 2,
        y2 - y1 + dashedLinePadding * 2,
        (x1 + x2) / 2,
        (y1 + y2) / 2,
        0,
      );
      context.lineWidth = lineWidth;
      context.setLineDash(initialLineDash);
      const transformHandles = getTransformHandlesFromCoords(
        [x1, y1, x2, y2, (x1 + x2) / 2, (y1 + y2) / 2],
        0,
        appState.zoom,
        "mouse",
        isFrameSelected
          ? OMIT_SIDES_FOR_FRAME
          : OMIT_SIDES_FOR_MULTIPLE_ELEMENTS,
      );
      if (selectedElements.some((element) => !element.locked)) {

        let nRotateElementCount = 0;//{text:0,image:0,shape:0,stickyNotes:0};
        selectedElements.forEach(p=>{
          if (isTextElement(p)){
            nRotateElementCount += 1;
          }else if (isShapeElement(p)){
            nRotateElementCount += 1;
          }else if (isImageElement(p)){
            nRotateElementCount += 1;
          }else if (isStickyNotesElement(p)){
            nRotateElementCount += 1;
          }
        })
        const nEleLen = selectedElements.length;
        if (nRotateElementCount == nEleLen){

        }else{
          delete transformHandles.rotation;
        }

        renderTransformHandles(
          context,
          renderConfig,
          appState,
          transformHandles,
          0,
            0
        );
      }
    }
    if (appState.hoveredElement){
      const { element, direction,status } = appState.hoveredElement;
      // 如果不被选中,hover显示中点
      if (element && direction && status && element.width > HOVER_CIRCLE_ELEMENT_SIZE && element.height > HOVER_CIRCLE_ELEMENT_SIZE) {
        renderHoverHandles({
          context,
          renderConfig,
          appState,
          element,
          direction,
        });
      }
    }


    context.restore();
  }

  appState.showSnapLines && renderSnaps(context, appState);

  // Reset zoom
  context.restore();


  // Paint remote pointers
  for (const clientId in renderConfig.remotePointerViewportCoords) {
    let { x, y } = renderConfig.remotePointerViewportCoords[clientId];

    x -= appState.offsetLeft;
    y -= appState.offsetTop;

    const width = 11;
    const height = 14;

    const isOutOfBounds =
      x < 0 ||
      x > normalizedWidth - width ||
      y < 0 ||
      y > normalizedHeight - height;

    x = Math.max(x, 0);
    x = Math.min(x, normalizedWidth - width);
    y = Math.max(y, 0);
    y = Math.min(y, normalizedHeight - height);

    const background = getClientColor(clientId);

    context.save();
    context.strokeStyle = background;
    context.fillStyle = background;

    const userState = renderConfig.remotePointerUserStates[clientId];
    const isInactive =
      isOutOfBounds ||
      userState === UserIdleState.IDLE ||
      userState === UserIdleState.AWAY;

    if (isInactive) {
      context.globalAlpha = 0.3;
    }

    if (
      renderConfig.remotePointerButton &&
      renderConfig.remotePointerButton[clientId] === "down"
    ) {
      context.beginPath();
      context.arc(x, y, 15, 0, 2 * Math.PI, false);
      context.lineWidth = 3;
      context.strokeStyle = "#ffffff88";
      context.stroke();
      context.closePath();

      context.beginPath();
      context.arc(x, y, 15, 0, 2 * Math.PI, false);
      context.lineWidth = 1;
      context.strokeStyle = background;
      context.stroke();
      context.closePath();
    }

    // Background (white outline) for arrow
    context.fillStyle = oc.white;
    context.strokeStyle = oc.white;
    context.lineWidth = 6;
    context.lineJoin = "round";
    context.beginPath();
    context.moveTo(x, y);
    context.lineTo(x + 0, y + 14);
    context.lineTo(x + 4, y + 9);
    context.lineTo(x + 11, y + 8);
    context.closePath();
    context.stroke();
    context.fill();

    // Arrow
    context.fillStyle = background;
    context.strokeStyle = background;
    context.lineWidth = 2;
    context.lineJoin = "round";
    context.beginPath();
    if (isInactive) {
      context.moveTo(x - 1, y - 1);
      context.lineTo(x - 1, y + 15);
      context.lineTo(x + 5, y + 10);
      context.lineTo(x + 12, y + 9);
      context.closePath();
      context.fill();
    } else {
      context.moveTo(x, y);
      context.lineTo(x + 0, y + 14);
      context.lineTo(x + 4, y + 9);
      context.lineTo(x + 11, y + 8);
      context.closePath();
      context.fill();
      context.stroke();
    }

    const username = renderConfig.remotePointerUsernames[clientId] || "";

    if (!isOutOfBounds && username) {
      context.font = "600 12px sans-serif"; // font has to be set before context.measureText()

      const offsetX = x + width / 2;
      const offsetY = y + height + 2;
      const paddingHorizontal = 5;
      const paddingVertical = 3;
      const measure = context.measureText(username);
      const measureHeight =
        measure.actualBoundingBoxDescent + measure.actualBoundingBoxAscent;
      const finalHeight = Math.max(measureHeight, 12);

      const boxX = offsetX - 1;
      const boxY = offsetY - 1;
      const boxWidth = measure.width + 2 + paddingHorizontal * 2 + 2;
      const boxHeight = finalHeight + 2 + paddingVertical * 2 + 2;
      if (context.roundRect) {
        context.beginPath();
        context.roundRect(boxX, boxY, boxWidth, boxHeight, 8);
        context.fillStyle = background;
        context.fill();
        context.strokeStyle = oc.white;
        context.stroke();
      } else {
        roundRect(context, boxX, boxY, boxWidth, boxHeight, 8, oc.white);
      }
      context.fillStyle = oc.black;

      context.fillText(
        username,
        offsetX + paddingHorizontal + 1,
        offsetY +
          paddingVertical +
          measure.actualBoundingBoxAscent +
          Math.floor((finalHeight - measureHeight) / 2) +
          2,
      );
    }

    context.restore();
    context.closePath();
  }

  // Paint scrollbars
  let scrollBars;
  if (renderConfig.renderScrollbars) {
    scrollBars = getScrollBars(
      elements,
      normalizedWidth,
      normalizedHeight,
      appState,
    );

    context.save();
    context.fillStyle = SCROLLBAR_COLOR;
    context.strokeStyle = "rgba(255,255,255,0.8)";
    [scrollBars.horizontal, scrollBars.vertical].forEach((scrollBar) => {
      if (scrollBar) {
        roundRect(
          context,
          scrollBar.x,
          scrollBar.y,
          scrollBar.width,
          scrollBar.height,
          SCROLLBAR_WIDTH / 2,
        );
      }
    });
    context.restore();
  }

  return {
    scrollBars,
    atLeastOneVisibleElement: visibleElements.length > 0,
    elements,
  };
};

const setCanvasPageSize = ({
                             context,
                             normalizedWidth,
                             normalizedHeight,
                             pageSizeValues,
                           }: {
  context: CanvasRenderingContext2D;
  normalizedWidth: number;
  normalizedHeight: number;
  pageSizeValues: AppState["pageSizeValues"];
}) => {
  const { type, width = 0, height = 0 } = pageSizeValues;
  if (type === "infinite") {
    return;
  }
  let clipWidth;
  let clipHeight;

  const baseWidth = (normalizedWidth / 10) * 9;
  const baseHeight = (normalizedHeight / 10) * 9;
  const aspectRatio = width / height;
  if (baseWidth / baseHeight > aspectRatio) {
    // 基于容器高度计算宽度
    clipHeight = baseHeight;
    clipWidth = clipHeight * aspectRatio;
  } else {
    // 基于容器宽度计算高度
    clipWidth = baseWidth;
    clipHeight = clipWidth / aspectRatio;
  }

  const center = {
    x: normalizedWidth / 2,
    y: normalizedHeight / 2,
  };
  let x = normalizedWidth / 20;
  const y = (normalizedHeight - clipHeight)*0.5;
  x = center.x - clipWidth / 2;

  context.rect(x, y, clipWidth, clipHeight);
  context.clip();
  return {
    x,
    y,
    clipWidth,
    clipHeight,
  };
};

const _renderStaticScene = ({
  canvas,
  rc,
  elements,
  visibleElements,
  scale,
  appState,
  renderConfig,
}: StaticSceneRenderConfig) => {
  if (canvas === null) {
    return;
  }

  const { renderGrid = true, isExporting } = renderConfig;

  const [normalizedWidth, normalizedHeight] = getNormalizedCanvasDimensions(
    canvas,
    scale,
  );
  normalizedSize = {
    normalizedWidth,
    normalizedHeight,
  };
  const context = bootstrapCanvas({
    canvas,
    scale,
    normalizedWidth,
    normalizedHeight,
    theme: appState.theme,
    isExporting,
    viewBackgroundColor: appState.viewBackgroundColor,
    pageSizeValues: appState.pageSizeValues,
  });

  // Apply zoom
  context.scale(appState.zoom.value, appState.zoom.value);

  // Grid
  if (renderGrid && appState.gridSize) {
    strokeGrid(
      context,
      appState.gridSize,
      appState.scrollX,
      appState.scrollY,
      appState.zoom,
      normalizedWidth / appState.zoom.value,
      normalizedHeight / appState.zoom.value,
    );
  }

  const groupsToBeAddedToFrame = new Set<string>();

  visibleElements.forEach((element) => {
    if (
      element.groupIds.length > 0 &&
      appState.frameToHighlight &&
      appState.selectedElementIds[element.id] &&
      (elementOverlapsWithFrame(element, appState.frameToHighlight) ||
        element.groupIds.find((groupId) => groupsToBeAddedToFrame.has(groupId)))
    ) {
      element.groupIds.forEach((groupId) =>
        groupsToBeAddedToFrame.add(groupId),
      );
    }
  });

  // Paint visible elements
  visibleElements
    .filter((el) => !isIframeLikeOrItsLabel(el))
    .forEach((element) => {
      try {
        const frameId = element.frameId || appState.frameToHighlight?.id;

        if (
          frameId &&
          appState.frameRendering.enabled &&
          appState.frameRendering.clip
        ) {
          context.save();

          const frame = getTargetFrame(element, appState);

          // TODO do we need to check isElementInFrame here?
          if (frame && isElementInFrame(element, elements, appState)) {
            // frameClip(frame, context, renderConfig, appState);
          }
          renderElement(element, rc, context, renderConfig, appState);
          context.restore();
        } else {
          renderElement(element, rc, context, renderConfig, appState);
        }
        if (!isExporting) {
          renderLinkIcon(element, context, appState);
        }
      } catch (error: any) {
        console.error(error);
      }
    });

  // render embeddables on top
  visibleElements
    .filter((el) => isIframeLikeOrItsLabel(el))
    .forEach((element) => {
      try {
        const render = () => {
          renderElement(element, rc, context, renderConfig, appState);

          if (
            // isIframeLikeElement(element) &&
              element.type != 'iframe' &&
            (isExporting ||
              (isEmbeddableElement(element) && !element.validated)) &&
            element.width &&
            element.height
          ) {
            const label = createPlaceholderEmbeddableLabel(element);
            renderElement(label, rc, context, renderConfig, appState);
          }
          if (!isExporting) {
            renderLinkIcon(element, context, appState);
          }
        };
        // - when exporting the whole canvas, we DO NOT apply clipping
        // - when we are exporting a particular frame, apply clipping
        //   if the containing frame is not selected, apply clipping
        const frameId = element.frameId || appState.frameToHighlight?.id;

        if (
          frameId &&
          appState.frameRendering.enabled &&
          appState.frameRendering.clip
        ) {
          context.save();

          const frame = getTargetFrame(element, appState);

          if (frame && isElementInFrame(element, elements, appState)) {
            frameClip(frame, context, renderConfig, appState);
          }
          render();
          context.restore();
        } else {
          render();
        }
      } catch (error: any) {
        console.error(error);
      }
    });
};

/** throttled to animation framerate */
const renderInteractiveSceneThrottled = throttleRAF(
  (config: InteractiveSceneRenderConfig) => {
    const ret = _renderInteractiveScene(config);
    config.callback?.(ret);
  },
  { trailing: true },
);

/**
 * Interactive scene is the ui-canvas where we render boundinb boxes, selections
 * and other ui stuff.
 */
export const renderInteractiveScene = <
  U extends typeof _renderInteractiveScene,
  T extends boolean = false,
>(
  renderConfig: InteractiveSceneRenderConfig,
  throttle?: T,
): T extends true ? void : ReturnType<U> => {
  if (throttle) {
    renderInteractiveSceneThrottled(renderConfig);
    return undefined as T extends true ? void : ReturnType<U>;
  }
  const ret = _renderInteractiveScene(renderConfig);
  renderConfig.callback(ret);
  return ret as T extends true ? void : ReturnType<U>;
};

/** throttled to animation framerate */
const renderStaticSceneThrottled = throttleRAF(
  (config: StaticSceneRenderConfig) => {
    _renderStaticScene(config);
  },
  { trailing: true },
);

/**
 * Static scene is the non-ui canvas where we render elements.
 */
export const renderStaticScene = (
  renderConfig: StaticSceneRenderConfig,
  throttle?: boolean,
) => {
  if (throttle) {
    renderStaticSceneThrottled(renderConfig);
    return;
  }

  _renderStaticScene(renderConfig);
};

export const cancelRender = () => {
  renderInteractiveSceneThrottled.cancel();
  renderStaticSceneThrottled.cancel();
};

/**
 * ****************************************************画操作的8个点***************************************************************************
 * @param context
 * @param renderConfig
 * @param appState
 * @param transformHandles
 * @param angle
 * @param elementHeight
 */
const renderTransformHandles = (
  context: CanvasRenderingContext2D,
  renderConfig: InteractiveCanvasRenderConfig,
  appState: InteractiveCanvasAppState,
  transformHandles: TransformHandles,
  angle: number,
  elementHeight:number
): void => {
  // if (appState)return;//这里不再画边框上的操作圆点。。。。

  Object.keys(transformHandles).forEach((key) => {
    const transformHandle = transformHandles[key as TransformHandleType];
    if (transformHandle !== undefined) {
      const [x, y, width, height] = transformHandle;

      context.save();
      context.lineWidth = 1 / appState.zoom.value;
      if (renderConfig.selectionColor) {
        context.strokeStyle = renderConfig.selectionColor;
      }
      if (key === "rotation") {
        // const size = 30;
        const size = 30 / appState.zoom.value;
        context.drawImage(
            getRotateImg(),
            x + width / 2 - size / 2,
            y + height / 2 - size / 2,
            size,
            size,
        );
        // context.strokeStyle = context.fillStyle = "#9AC2FC";
        // fillCircle(context, x + width / 2, y + height / 2, width / 2);
        // fillRotateImage(context,x + (width-IMAGE_ROTATE_SIZE) / 2, y + elementHeight + IMAGE_ROTATE_SIZE + 30)
        // prefer round corners if roundRect API is available
      } else if (context.roundRect) {
        // context.beginPath();
        // context.roundRect(x, y, width, height, (width*0.5) / appState.zoom.value);
        // context.fill();
        // context.stroke();
      } else {
        strokeRectWithRotation(
          context,
          x,
          y,
          width,
          height,
          x + width / 2,
          y + height / 2,
          angle,
          true, // fill before stroke
        );
      }
      context.restore();
    }
  });
};

const renderQuickflowHandles = ({
                                  context,
                                  renderConfig,
                                  appState,
                                  element,
                                }: {
  context: CanvasRenderingContext2D;
  renderConfig: InteractiveCanvasRenderConfig;
  appState: InteractiveCanvasAppState;
  element: NonDeletedExcalidrawElement;
}): void => {
  // const [x1, y1, x2, y2] = getElementAbsoluteCoords(element);
  // const [x, y, width, height] = getLinkHandleFromCoords(
  //   [x1, y1, x2, y2],
  //   element.angle,
  //   appState,
  // );
  // const centerX = x + width / 2;
  // const centerY = y + height / 2;

  // const centerX = element.x + element.width / 2;
  // const centerY = element.y + element.height / 2;

  // context.save();
  // context.translate(appState.scrollX, appState.scrollY);
  // context.rotate(element.angle);

  const quickFlowHandles = getQuickFlowHandles({
    element,
    appState,
    size: 4.6,
  });
  context.save();

  Object.entries(quickFlowHandles).forEach(([key, value]) => {
    if (value !== undefined) {
      const { x, y, width, height, quickFlowImage } = value;
      const scale = appState.zoom.value > 1 ? appState.zoom.value : 1;
      context.save();
      const lineWidth = key === appState.quickFlowConfig.activeHandle ? 3 : 1;
      context.lineWidth = 0;//lineWidth / (appState.zoom.value > 1 ? 1 : appState.zoom.value);
      if (renderConfig.selectionColor) {
        context.strokeStyle = renderConfig.selectionColor;
      }
      //#5168f6
      if (key === appState.quickFlowConfig.activeHandle) {
        context.strokeStyle = "#6780FFAA"; // 设置描边颜色
      }

      let isDrawCircle = true;
      if (isNoteElement(element)){
        if (Global.g_isCanvasCardMouseDown){
          isDrawCircle = false;
        }
      }
      if (isDrawCircle){
        fillCircle(context, x + width / 2, y + height / 2, width, true, true);
      }

      context.restore();
    }
  });
  context.restore();
};

const renderHoverHandles = ({
                              context,
                              renderConfig,
                              appState,
                              element,
                              direction,
                            }: {
  context: CanvasRenderingContext2D;
  renderConfig: InteractiveCanvasRenderConfig;
  appState: InteractiveCanvasAppState;
  element: NonDeletedExcalidrawElement;
  direction: "top" | "right" | "bottom" | "left";
}): void => {
  if (APP_WEB)return;

  const quickFlowHandles = getHoverHandles({
    element,
    appState,
    size: 9,
  });
  context.save();

  Object.entries(quickFlowHandles).forEach(([key, value]) => {
    if (value !== undefined && key === direction) {
      let { x, y, width, height } = value;
      const scale = appState.zoom.value > 1 ? appState.zoom.value : 1;
      context.save();
      const lineWidth = 0;//appState.hoveredElement.status === "highlight" ? 6 : 1;
      context.lineWidth = lineWidth / appState.zoom.value;
      if (renderConfig.selectionColor) {
        context.strokeStyle = renderConfig.selectionColor;
      }

      if (appState.hoveredElement.status === "highlight") {

      }

      const nRevertZoom = (1/appState.zoom.value);
      width = height = 10 * nRevertZoom;

      if ((isImageElement(element) && !element.customData?.generationData?.isShowInfoNotes) || isShapeElement(element)){
        context.strokeStyle = "#3670F7"; // 设置描边颜色
        context.fillStyle = '#3670F7';
      }else{
        context.strokeStyle = "transparent"; // 设置描边颜色
        context.fillStyle = 'transparent';
      }

      const [rotatedX, rotatedY] = rotate(
          x + 10 / 2,
          y + 10 / 2,
          element.x + element.width / 2,
          element.y + element.height / 2,
          element.angle,
      );

      fillCircle(context, rotatedX, rotatedY, width, true, true);

      context.restore();
    }
  });
  context.restore();
};

const renderSelectionBorder = (
  context: CanvasRenderingContext2D,
  appState: InteractiveCanvasAppState,
  elementProperties: {
    angle: number;
    elementX1: number;
    elementY1: number;
    elementX2: number;
    elementY2: number;
    selectionColors: string[];
    dashed?: boolean;
    cx: number;
    cy: number;
    activeEmbeddable: boolean;
    corner:any;
  },
  padding = DEFAULT_SPACING * 2,
) => {
  const {
    angle,
    elementX1,
    elementY1,
    elementX2,
    elementY2,
    selectionColors,
    cx,
    cy,
    dashed,
    activeEmbeddable,
      corner,
  } = elementProperties;
  const elementWidth = elementX2 - elementX1;
  const elementHeight = elementY2 - elementY1;

  const linePadding = padding / appState.zoom.value;
  const lineWidth = 8 / appState.zoom.value;
  const spaceWidth = 4 / appState.zoom.value;

  context.save();
  context.translate(appState.scrollX, appState.scrollY);
  context.lineWidth = (activeEmbeddable ? 4 : 2) / appState.zoom.value;// (activeEmbeddable ? 4 : 1) / appState.zoom.value;

  const count = selectionColors.length;
  for (let index = 0; index < count; ++index) {
    context.strokeStyle = selectionColors[index];
    if (dashed) {
      context.setLineDash([
        lineWidth,
        spaceWidth + (lineWidth + spaceWidth) * (count - 1),
      ]);
    }
    context.lineDashOffset = (lineWidth + spaceWidth) * index;
    strokeRectWithRotation(
      context,
      elementX1 - linePadding,
      elementY1 - linePadding,
      elementWidth + linePadding * 2,
      elementHeight + linePadding * 2,
      cx,
      cy,
      angle,
        false,
        corner || 0
    );

  }
  context.restore();
};

const renderBindingHighlight = (
  context: CanvasRenderingContext2D,
  appState: InteractiveCanvasAppState,
  suggestedBinding: SuggestedBinding,
) => {
  const renderHighlight = Array.isArray(suggestedBinding)
    ? renderBindingHighlightForSuggestedPointBinding
    : renderBindingHighlightForBindableElement;

  context.save();
  context.translate(appState.scrollX, appState.scrollY);
  renderHighlight(context, suggestedBinding as any);

  context.restore();
};

const renderBindingHighlightForBindableElement = (
  context: CanvasRenderingContext2D,
  element: ExcalidrawBindableElement,
) => {
  const [x1, y1, x2, y2] = getElementAbsoluteCoords(element);
  const width = x2 - x1;
  const height = y2 - y1;
  const threshold = maxBindingGap(element, width, height);

  // So that we don't overlap the element itself
  const strokeOffset = 4;
  context.strokeStyle = "rgba(0,0,0,.05)";
  context.lineWidth = threshold - strokeOffset;
  const padding = strokeOffset / 2 + threshold / 2;

  renderBindingPointsByLine(
      context,
      x1,
      y1,
      width,
      height,
      x1 + width / 2,
      y1 + height / 2,
      element.angle,
  );

  switch (element.type) {
    case "rectangle":
    case "roundedRectangle":
    case "triangle":
    case "bubble":
    case "parallelogram":
    case "pentagram":
    case "thickArrow":
    case "text":
    case "image":
    case "iframe":
    case "embeddable":
    case "stickyNotes":
    case "mindmap":
    case "frame":
    case "magicframe":
      strokeRectWithRotation(
        context,
        x1 - padding,
        y1 - padding,
        width + padding * 2,
        height + padding * 2,
        x1 + width / 2,
        y1 + height / 2,
        element.angle,
      );
      break;
    case "diamond":
      const side = Math.hypot(width, height);
      const wPadding = (padding * side) / height;
      const hPadding = (padding * side) / width;
      strokeDiamondWithRotation(
        context,
        width + wPadding * 2,
        height + hPadding * 2,
        x1 + width / 2,
        y1 + height / 2,
        element.angle,
      );
      break;
    case "ellipse":
      strokeEllipseWithRotation(
        context,
        width + padding * 2,
        height + padding * 2,
        x1 + width / 2,
        y1 + height / 2,
        element.angle,
      );
      break;
  }
};

const renderBindingPointsByLine = (
    context: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    cx: number,
    cy: number,
    angle: number,
) => {
  context.save();
  context.translate(cx, cy);
  context.rotate(angle);
  context.strokeStyle = "blue";
  context.lineWidth = 2;
  context.fillStyle = "white";

  const x1 = x - cx;
  const y1 = y - cy;
  const x2 = x + width - cx;
  const y2 = y + height - cy;

  fillCircle(context, x1 + width / 2, y1, 5);
  fillCircle(context, x2, y1 + height / 2, 5);
  fillCircle(context, x1 + width / 2, y2, 5);
  fillCircle(context, x1, y1 + height / 2, 5);

  context.restore();
};

const renderFrameHighlight = (
  context: CanvasRenderingContext2D,
  appState: InteractiveCanvasAppState,
  frame: NonDeleted<ExcalidrawFrameLikeElement>,
) => {
  const [x1, y1, x2, y2] = getElementAbsoluteCoords(frame);
  const width = x2 - x1;
  const height = y2 - y1;

  context.strokeStyle = "rgb(0,118,255)";
  context.lineWidth = FRAME_STYLE.strokeWidth / appState.zoom.value;

  context.save();
  context.translate(appState.scrollX, appState.scrollY);
  strokeRectWithRotation(
    context,
    x1,
    y1,
    width,
    height,
    x1 + width / 2,
    y1 + height / 2,
    frame.angle,
    false,
    FRAME_STYLE.radius / appState.zoom.value,
  );
  context.restore();
};

const renderElementsBoxHighlight = (
  context: CanvasRenderingContext2D,
  appState: InteractiveCanvasAppState,
  elements: NonDeleted<ExcalidrawElement>[],
) => {
  const individualElements = elements.filter(
    (element) => element.groupIds.length === 0,
  );

  const elementsInGroups = elements.filter(
    (element) => element.groupIds.length > 0,
  );

  const getSelectionFromElements = (elements: ExcalidrawElement[]) => {
    const [elementX1, elementY1, elementX2, elementY2,corner] =
      getCommonBounds(elements);
    return {
      angle: 0,
      elementX1,
      elementX2,
      elementY1,
      elementY2,
      selectionColors: ["rgb(0,118,255)"],
      dashed: false,
      cx: elementX1 + (elementX2 - elementX1) / 2,
      cy: elementY1 + (elementY2 - elementY1) / 2,
      activeEmbeddable: false,
      corner:corner || 8
    };
  };

  const getSelectionForGroupId = (groupId: GroupId) => {
    const groupElements = getElementsInGroup(elements, groupId);
    return getSelectionFromElements(groupElements);
  };

  const aaaaaaaa = Object.entries(selectGroupsFromGivenElements(elementsInGroups, appState))
    .filter(([id, isSelected]) => isSelected)
    .map(([id, isSelected]) => id)
    .map((groupId) => getSelectionForGroupId(groupId))
    .concat(
      individualElements.map((element) => getSelectionFromElements([element])),
    );
    aaaaaaaa.forEach((selection) =>
      renderSelectionBorder(context, appState, selection),
    );
};

const renderBindingHighlightForSuggestedPointBinding = (
  context: CanvasRenderingContext2D,
  suggestedBinding: SuggestedPointBinding,
) => {
  const [element, startOrEnd, bindableElement] = suggestedBinding;

  const threshold = maxBindingGap(
    bindableElement,
    bindableElement.width,
    bindableElement.height,
  );

  context.strokeStyle = "rgba(0,0,0,0)";
  context.fillStyle = "rgba(0,0,0,.05)";

  const pointIndices =
    startOrEnd === "both" ? [0, -1] : startOrEnd === "start" ? [0] : [-1];
  pointIndices.forEach((index) => {
    const [x, y] = LinearElementEditor.getPointAtIndexGlobalCoordinates(
      element,
      index,
    );
    fillCircle(context, x, y, threshold);
  });
};

let linkCanvasCache: any;
const renderLinkIcon = (
  element: NonDeletedExcalidrawElement,
  context: CanvasRenderingContext2D,
  appState: StaticCanvasAppState,
) => {
  if (element.link && !appState.selectedElementIds[element.id]) {
    const [x1, y1, x2, y2] = getElementAbsoluteCoords(element);
    const [x, y, width, height] = getLinkHandleFromCoords(
      [x1, y1, x2, y2],
      element.angle,
      appState,
    );
    const centerX = x + width / 2;
    const centerY = y + height / 2;
    context.save();
    context.translate(appState.scrollX + centerX, appState.scrollY + centerY);
    context.rotate(element.angle);

    if (!linkCanvasCache /*|| linkCanvasCache.zoom !== appState.zoom.value*/) {
      linkCanvasCache = document.createElement("canvas");
      linkCanvasCache.zoom = appState.zoom.value;
      linkCanvasCache.width =
        width * window.devicePixelRatio * appState.zoom.value;
      linkCanvasCache.height =
        height * window.devicePixelRatio * appState.zoom.value;
      const linkCanvasCacheContext = linkCanvasCache.getContext("2d")!;
      linkCanvasCacheContext.scale(
        window.devicePixelRatio * appState.zoom.value,
        window.devicePixelRatio * appState.zoom.value,
      );
      linkCanvasCacheContext.fillStyle = "transparent";//"#fff";
      linkCanvasCacheContext.fillRect(0, 0, width, height);
      if ((!APP_WEB && !appState.extra?.isPresentMode && appState.activeTool.type != 'laser'))
      {
        linkCanvasCacheContext.drawImage(EXTERNAL_LINK_IMG, 0, 0, width, height);
        linkCanvasCacheContext.restore();
      }
      context.drawImage(
        linkCanvasCache,
        x - centerX,
        y - centerY,
        width,
        height,
      );
    } else {
      if ((!appState.extra?.isPresentMode && appState.activeTool.type != 'laser') || APP_WEB)
      {
        context.drawImage(
            linkCanvasCache,
            x - centerX,
            y - centerY,
            width,
            height,
        );
      }
    }

    context.restore();
  }
};

// This should be only called for exporting purposes
export const renderSceneToSvg = (
  elements: readonly NonDeletedExcalidrawElement[],
  rsvg: RoughSVG,
  svgRoot: SVGElement,
  files: BinaryFiles,
  renderConfig: SVGRenderConfig,
) => {
  if (!svgRoot) {
    return;
  }

  // render elements
  elements
    .filter((el) => !isIframeLikeOrItsLabel(el))
    .forEach((element) => {
      if (!element.isDeleted) {
        try {
          renderElementToSvg(
            element,
            rsvg,
            svgRoot,
            files,
            element.x + renderConfig.offsetX,
            element.y + renderConfig.offsetY,
            renderConfig,
          );
        } catch (error: any) {
          console.error(error);
        }
      }
    });

  // render embeddables on top
  elements
    .filter((el) => isIframeLikeElement(el))
    .forEach((element) => {
      if (!element.isDeleted) {
        try {
          renderElementToSvg(
            element,
            rsvg,
            svgRoot,
            files,
            element.x + renderConfig.offsetX,
            element.y + renderConfig.offsetY,
            renderConfig,
          );
        } catch (error: any) {
          console.error(error);
        }
      }
    });
};
